module.exports = __webpack_public_path__ + "img/answer-c3-4.2b4643fe.png";